<template>
    <div v-if="!isSubscribed" class="he-subscribe">
        <p v-if="!isMobileSize">{{ $t('md-evaluation-banner.subscribeDesc') }}</p>
        <button class="he-subscribe-btn" @click="onSubscribe">
            {{ $t('md-evaluation-banner.subscribeText') }}
        </button>
    </div>
</template>
<script>
import { mapActions as rootMapActions } from 'pinia';
import { useChatStore } from '@/store';

import util from '@/common/util';
export default {
    name: 'HomeEvaluationSubscribe',
    i18next: {
        ns: 'md-evaluation-banner'
    },
    inject: ['homeReportInfo'],
    data: function() {
        return {
            isSubscribed: true
        };
    },
    watch: {
        'homeReportInfo.id': {
            immediate: true,
            handler(id) {
                this.getHomeReportInfo(id);
            }
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    methods: {
        ...rootMapActions(useChatStore, {
            "updateChatPosition": "updateChatPosition",
            "resetChatPosition": "resetChatPosition"
        }),
        
        async onSubscribe() {
            let res = await this.axiosIns.get(
                '/home-report/home-estimate/subscribe/' + this.homeReportInfo.id
            );
            if (res.status.code === 0) {
                this.isSubscribed = true;
                this.resetChatPosition();
                util.toast(this.$t('md-evaluation-banner.subscribeTip'), 3000);
            }
        },
        async getHomeReportInfo(id) {
            if (!id) {
                return; 
            }
            let res = await this.axiosIns.get(
                `/home-report/landing-page/home-estimate/${id}?_t=${Date.now()}`
            );
            if (res.status.code === 0) {
                this.isSubscribed = res.data.subscribe;
                if (!this.isSubscribed) {
                    this.updateChatPosition({
                        bottom: '110px',
                        mBottom: '110px'
                    });
                }
            }
        }
    },
    beforeDestory() {
        this.resetChatPosition();
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
.he-subscribe {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    @include media-min-600 {
        background: #2e2e2e;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 15px;
        height: 100px;
        p {
            font-family: var(--font-normal);
            font-size: 16px;
            line-height: 24px;
            color: #e2e2e2;
            margin-right: 20px;
        }
    }
    @include media-600 {
        bottom: 50px;
    }
    .he-subscribe-btn {
        flex-shrink: 0;
        height: 50px;
        font-weight: 600;
        font-size: 16px;
        width: 150px;
        border-radius: 8px;
        color: var(--mg-button-color);
        font-family: var(--mg-button-font);
        background-color: var(--color-theme);
        // &:hover {
        //     background-color: var(--color-hover);
        // }
        @include media-600 {
            margin-left: 50%;
            transform: translateX(-50%);
            font-size: 14px;
            color: var(--color-theme);
            background-color: #fff;
            width: 84%;
            border-radius: 45px;
            box-shadow: 0px 4px 14px rgba(129, 149, 189, 0.15);
            &:hover {
                background-color: #fff;
            }
        }
    }
}
</style>
